import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { mobileVerification } from '../api/Api';

const MobileVerificationForm = () => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [verificationInProgress, setVerificationInProgress] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const navigate = useNavigate();

  const handleSendOTP = async (e) => {
    e.preventDefault();
    if (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber)) {
      alert('Please enter a valid 10-digit mobile number.');
      return;
    }
    const mobileRequest = {
      mobileNumber,
    };

    try {
      const response = await mobileVerification(mobileRequest);
      alert(response.data); // Show response message
      setVerificationInProgress(true);
    } catch (error) {
      alert('Error sending OTP: ' + (error.response?.data || error.message));
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    if (otp.length !== 6 || !/^\d+$/.test(otp)) {
      alert('Please enter a valid 6-digit OTP.');
      return;
    }

    try {
      const response = await axios.post(
        `http://localhost:8080/api/mobile/verify-otp?mobileNumber=${mobileNumber}&otp=${otp}`
      );
      alert(response.data); // Show response message
      setIsVerified(true);
    } catch (error) {
      alert('Error verifying OTP: ' + (error.response?.data || error.message));
    }
  };

  const handleNext = () => {
    if (isVerified) {
      navigate('/emailverification');
    } else {
      alert('Please verify OTP first.');
    }
  };

  const handleBack = () => {
    navigate('/applynow');
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <form className="bg-white p-6 rounded shadow-md w-96">
        <h2 className="text-2xl font-bold mb-4">Verify your Mobile Number</h2>

        {!verificationInProgress ? (
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">Mobile Number</label>
            <input
              type="text"
              placeholder="Enter Mobile Number"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              maxLength={10}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
        ) : (
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">Enter OTP</label>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              maxLength={6}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
        )}

        <div className="flex items-center justify-between">
          <button
            type="button"
            onClick={handleBack}
            className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Back
          </button>

          {!verificationInProgress ? (
            <button
              onClick={handleSendOTP}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Send OTP
            </button>
          ) : !isVerified ? (
            <button
              onClick={handleVerifyOTP}
              className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Verify OTP
            </button>
          ) : (
            <button
              onClick={handleNext}
              className="bg-blue-800 hover:bg-blue-900 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Next
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default MobileVerificationForm;
